// Default theme
export const complexedesjardins = {
  header_background_color: '#21376d',
  logo_image_url: 'complexedesjardins/default.png',
  logo_height: 90,
  token_url: 'complexedesjardins/default.png',
  number_hidden: true,
  image_icon_hidden: true,
  button_color: '#21376d',
  button_text_uppercase: true,
  button_radius: 3,
  button_half_border_color: '#21376d',
  text_font: `'Roboto', sans-serif`,
  title_font: `'Roboto', sans-serif`,
}

// Commerce
export const complexedesjardins_commerces = {
  ...complexedesjardins,
  logo_image_url: 'complexedesjardins/commerces.png',
}

// Grande Place
export const complexedesjardins_grandeplace = {
  ...complexedesjardins,
  body_background_color: '#78c7c9',
  header_background_color: '#3e2778',
  logo_image_url: 'complexedesjardins/grandeplace.png',
  token_url: 'complexedesjardins/grandeplace.png',
  button_color: '#3e2778',
  button_half_border_color: '#3e2778',
}

// Paysages
export const complexedesjardins_paysages = {
  ...complexedesjardins,
  logo_image_url: 'complexedesjardins/paysages.png',
}

// Rouge
export const complexedesjardins_rouge = {
  ...complexedesjardins,
  body_background_color: '#BD1B22',
  body_background_image_url: 'complexedesjardins/rouge.png',
  body_background_image_repeat: true,
  header_background_url: 'complexedesjardins/rouge.png',
  logo_hidden: true,
  header_height: 110,
  token_url: 'complexedesjardins/rouge.png',
  button_color: '#BD1B22',
  button_half_border_color: '#BD1B22',
}
